<template>
	<div>
		<position-template-editor />
	</div>
</template>

<script>
	import PositionTemplateEditor from '@/components/positionTemplate/PositionTemplateEditor';

	export default {
		name: 'PagePositionTemplateCreate',
		data() {
			return {}
		},
		components: {
			PositionTemplateEditor
		},
		methods: {
			onCancel() {
				window.history.back();
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Create New Position Template');
		}
	};
</script>

<style></style>
